module.exports = __webpack_public_path__ + "img/Frame 427319318.f2f5171a.png";